import StreambotPageContent from './StreambotPageContent'
export { StreambotWidgetWrapper, useGetWidgetComponentProps } from './StreambotPageContent'
export default StreambotPageContent
